var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.classes.wrapper }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showToolbar,
            expression: "showToolbar",
          },
        ],
        class: _vm.classes.toolbar,
      },
      [
        _c("div", { attrs: { role: "search" } }, [
          _c(
            "label",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSearch,
                  expression: "showSearch",
                },
              ],
              class: _vm.classes.searchLabel,
              attrs: { for: `dataTableSearch${_vm.uid}` },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.languageData.searchLabel) +
                  "\n                "
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchTerm,
                    expression: "searchTerm",
                  },
                ],
                class: _vm.classes.searchInput,
                attrs: { id: `dataTableSearch${_vm.uid}`, type: "text" },
                domProps: { value: _vm.searchTerm },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.searchTerm = $event.target.value
                  },
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "label",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPagesize,
                expression: "showPagesize",
              },
            ],
            class: _vm.classes.pageSizeLabel,
            attrs: { for: `dataTablePageSize${_vm.uid}` },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.languageData.pageSizeLabel) +
                "\n            "
            ),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rowsPerPage,
                    expression: "rowsPerPage",
                  },
                ],
                class: _vm.classes.searchInput,
                attrs: { id: `dataTablePageSize${_vm.uid}` },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.rowsPerPage = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.rowsPerPageOptions, function (option) {
                return _c("option", { key: option }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(option) +
                      "\n                "
                  ),
                ])
              }),
              0
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "table",
      { class: _vm.classes.table, attrs: { id: _vm.uniqueTableId } },
      [
        _c("thead", { class: _vm.classes.thead }, [
          _c(
            "tr",
            { class: _vm.classes.theadTr },
            _vm._l(_vm.columns, function (th, thIndex) {
              return _c(
                "th",
                {
                  key: `${th.name}--${thIndex}`,
                  class: _vm.headerClasses(thIndex),
                  attrs: {
                    "aria-controls": _vm.uniqueTableId,
                    "aria-label":
                      !th.name && thIndex === 0
                        ? _vm.trans("GLOBAL_CHARACTERISTIC")
                        : undefined,
                    scope: "col",
                    tabindex: "0",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setSortColumnIndex(thIndex)
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.setSortColumnIndex(thIndex)
                    },
                  },
                },
                [
                  th.html
                    ? _c("span", { domProps: { innerHTML: _vm._s(th.name) } })
                    : [
                        _vm._v(
                          "\n                        " +
                            _vm._s(th.name) +
                            "\n                    "
                        ),
                      ],
                ],
                2
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          {
            class: _vm.classes.tbody,
            attrs: { "aria-live": "polite", "aria-relevant": "all" },
          },
          _vm._l(_vm.pagedRows, function (row, rowIndex) {
            return _c(
              "tr",
              {
                key: rowIndex,
                class: _vm.classes.tbodyTr,
                on: {
                  click: function ($event) {
                    return _vm.$emit("click", row)
                  },
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.$emit("click", row)
                  },
                },
              },
              _vm._l(row, function (col, colIndex) {
                return _c(
                  "td",
                  {
                    key: colIndex,
                    class: [
                      _vm.columnClasses(colIndex),
                      _vm.setNoWrapClass(col.value),
                    ],
                    style: { backgroundColor: col.backgroundColor },
                  },
                  [
                    col.trend
                      ? _c("span", { attrs: { "data-trend": col.trend } })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.columns[colIndex] && _vm.columns[colIndex].html
                      ? _c("span", {
                          domProps: { innerHTML: _vm._s(col.value) },
                        })
                      : [
                          _c("div", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(col.value) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          col.description
                            ? _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    "hide-on-mobile": true,
                                    content: col.description,
                                    settings: { position: "left" },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "stat__svgIcon--small opacity-50",
                                      attrs: {
                                        "aria-describedby": _vm.trans(
                                          "OUTLOOK_ADDITIONAL_INFORMATION_SHOW"
                                        ),
                                      },
                                    },
                                    [
                                      _c("use", {
                                        attrs: { href: "#iconInfoCircle" },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                  ],
                  2
                )
              }),
              0
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.sortedRows.length === 0
          ? _c("tbody", [
              _c("tr", [
                _c(
                  "td",
                  {
                    class: _vm.classes.empty,
                    attrs: { colspan: _vm.columns.length },
                  },
                  [
                    _vm._t("noResults", function () {
                      return [
                        _vm._v(
                          "\n                        No matching records\n                    "
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _vm.showFooter
      ? _c("div", { class: _vm.classes.footer }, [
          _vm.showRangeLabel
            ? _c("div", { class: _vm.classes.rangeLabel }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.pageRangeLabelFormatted) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.pagerVisible
            ? _c(
                "div",
                { attrs: { "data-test": "dataTable__pager" } },
                [
                  _c(
                    "button",
                    {
                      class: _vm.classes.pagePrev,
                      attrs: {
                        disabled: _vm.currentPage === _vm.defaultPage,
                        "aria-label": "Show previous page",
                        type: "button",
                      },
                      on: {
                        click: _vm.prevPage,
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.prevPage.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.languageData.pagePrev) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showPageNumber
                    ? [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.currentPage) +
                            "\n            "
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      class: _vm.classes.pageNext,
                      attrs: {
                        disabled: _vm.currentPage === _vm.pagesCount,
                        "aria-label": "Show next page",
                        type: "button",
                      },
                      on: {
                        click: _vm.nextPage,
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.nextPage.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.languageData.pageNext) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                2
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }